import {Button, ListItem, ListItemIcon, ListItemText, MenuItem, Menu} from '@material-ui/core';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import AgentFormsRouteConstants from 'Agent/AgentForms/AgentFormsRouteConstants';
import 'Core/components/Navigation/MyAccessMenu.sass';
import React from 'react';
import {useHistory} from 'react-router';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import NestedList from 'Shared/components/NestedList';
import withSelectedAgency, {WithSelectedAgencyProps} from 'Shared/components/withSelectedAgency';
import withUserClaims, {WithClaimsProps} from 'Shared/components/withUserClaims';
import {useWidth} from 'Shared/utilities/UseWidth';

export type FormMenuProps = WithSelectedAgencyProps &
  WithClaimsProps & {
    onSidebarClose?: () => void;
  };

const FormMenu = ({onSidebarClose}: FormMenuProps) => {
  const width = useWidth();
  const history = useHistory();
  const isMobileView = ['xs', 'sm', 'md'].includes(width);

  const MobileView = (
    <NestedList mainListItemTitle="Forms" isExpanded={false}>
      <div>
        <ListItem
          button
          onClick={() => {
            history.push(AgentFormsRouteConstants.AGENCY_BULLETIN);
            if (onSidebarClose) {
              onSidebarClose();
            }
          }}
        >
          <ListItemIcon>
            <i className="fa fa-file sidebar__menu-icon" />
          </ListItemIcon>
          <ListItemText>Bulletins</ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push(AgentFormsRouteConstants.INTERACTIVE_FORMS);
            if (onSidebarClose) {
              onSidebarClose();
            }
          }}
        >
          <ListItemIcon>
            <i className="fa fa-file sidebar__menu-icon" />
          </ListItemIcon>
          <ListItemText>Interactive Forms</ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push(AgentFormsRouteConstants.MARKETING_FORMS);
            if (onSidebarClose) {
              onSidebarClose();
            }
          }}
        >
          <ListItemIcon>
            <i className="fa fa-file sidebar__menu-icon" />
          </ListItemIcon>
          <ListItemText>Marketing Forms</ListItemText>
        </ListItem>
        <ListItem
          button
          onClick={() => {
            history.push(AgentFormsRouteConstants.PREVIOUS_ORDERS);
            if (onSidebarClose) {
              onSidebarClose();
            }
          }}
        >
          <ListItemIcon>
            <i className="fa fa-file sidebar__menu-icon" />
          </ListItemIcon>
          <ListItemText>Previous Orders</ListItemText>
        </ListItem>
      </div>
    </NestedList>
  );
  return isMobileView ? (
    MobileView
  ) : (
    <MenuStateProvider>
      {({anchor, close, open, firstMenuItemRef, focusFirstMenuItem}) => (
        <>
          <Button
            id="my-allstate-menu-button"
            className="my-access-menu"
            variant="text"
            onClick={event => open(event.currentTarget)}
            aria-haspopup="true"
            aria-controls="forms-menu"
            aria-expanded={Boolean(anchor)}
          >
            Forms
            <ArrowDown />
          </Button>
          <Menu
            id="forms-menu"
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            transformOrigin={{vertical: 'top', horizontal: 'center'}}
            getContentAnchorEl={null}
            onClose={close}
            open={Boolean(anchor)}
            anchorEl={anchor}
            TransitionProps={{onEntered: focusFirstMenuItem}}
          >
            <>
              <MenuItem
                id="accounts-my-allstate-option"
                className="my-access-menu__item"
                onClick={() => {
                  history.push(AgentFormsRouteConstants.AGENCY_BULLETIN);
                  close();
                }}
                ref={firstMenuItemRef}
              >
                Bulletins
              </MenuItem>
              <MenuItem
                id="accounts-my-allstate-option"
                className="my-access-menu__item"
                onClick={() => {
                  history.push(AgentFormsRouteConstants.INTERACTIVE_FORMS);
                  close();
                }}
              >
                Interactive Forms
              </MenuItem>
              <MenuItem
                id="accounts-my-allstate-option"
                className="my-access-menu__item"
                onClick={() => {
                  history.push(AgentFormsRouteConstants.MARKETING_FORMS);
                  close();
                }}
              >
                Marketing Forms
              </MenuItem>
              <MenuItem
                id="accounts-my-allstate-option"
                className="my-access-menu__item"
                onClick={() => {
                  history.push(AgentFormsRouteConstants.PREVIOUS_ORDERS);
                  close();
                }}
              >
                Previous Orders
              </MenuItem>
            </>
          </Menu>
        </>
      )}
    </MenuStateProvider>
  );
};

export default withSelectedAgency(withUserClaims(FormMenu));
